import ByzTitleBox from "../component/title-box";
import { Box, Card, Grid } from "@mui/material";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";
//MPOGLU;453141;09042025
function PageOne() {
  const { t } = useTranslate();

  return (
    <Card sx={{ marginBottom: "5px" }}>
      <ByzTitleBox title={t("blood-transfusion.laboratory-results")} />
      <Grid container spacing={1} p={1}>
        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox title={t("blood-transfusion.indirect-coombs")}>
            <ByzMuiRadioButton
              typographyText="blood-transfusion.positive,blood-transfusion.negative"
              layout="row"
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox title={t("blood-transfusion.test-studied")}>
            <ByzMuiRadioButton
              typographyText="blood-transfusion.suitable,blood-transfusion.not-suitable,blood-transfusion.negative"
              layout="row"
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox title={t("blood-transfusion.crossmatch-result")}>
            <ByzMuiTextField />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox title={t("blood-transfusion.crossmatcher")}>
            <ByzMuiTextField />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <ByzTitleBox title={t("blood-transfusion.case-reaction")} />

      <Grid
        item
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item md={6} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.stop-transfusion-immediately")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.keep-vein-open-with-saline")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.take-blood-samples-from-other-arm")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.suspicious-adverse-event-procedure")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.send-blood-and-set-for-examination")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item md={6} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.notify-transfusion-and-hemovigilance")}
          >
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 3 }}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <ByzTitleBox title={t("blood-transfusion.transfer-information")} />

      <Grid container spacing={1} p={1}>
        <Grid item sm={6} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.delivered-by-name-surname")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <Box height="16px"></Box>
            <ByzTitleAndInputBox title={t("blood-transfusion.date-and-time")}>
              <ByzMuiDatePicker label="" />
            </ByzTitleAndInputBox>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.transfer-performed-by")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <Box height="16px"></Box>

            <ByzTitleAndInputBox title={t("blood-transfusion.date-and-time")}>
              <ByzMuiDatePicker label="" />
            </ByzTitleAndInputBox>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.received-by-clinic")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
            <Box height="16px"></Box>
            <ByzTitleAndInputBox title={t("blood-transfusion.date-and-time")}>
              <ByzMuiDatePicker label="" />
            </ByzTitleAndInputBox>
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <ByzTitleBox
        title={t("blood-transfusion.transfusion-before-component-check")}
      />

      <Grid
        item
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={3} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.person-1")}            
          >
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.patient-identity-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.patient-blood-group-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.crossmatch-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.component-bag-number-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.microbiology-test-negative")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.storage-degree")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ marginBottom: "8px", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.product-accuracy-check")}
            </ByzMuiTypography>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.person-1")}>
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={1} xs={12} md={1} lg={1} xl={1}>
          <ByzTitleAndInputBox title={t("blood-transfusion.person-2")}>
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
            <ByzMuiCheckBox
              sx={{ display: "flex", justifyContent: "flex-start", ml: 1 }}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={2} xs={12} md={2} lg={2} xl={2} mb={2}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.person-1")}
          >
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.component-color-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.particulate-matter-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.hemolysis-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.take-skt-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.bag-zıntı-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ visibility: "hidden", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.bag-zıntı-check")}
            </ByzMuiTypography>
            <ByzMuiTypography
              variant="body1"
              color="black"
              sx={{ visibility: "hidden", textAlign: "left", opacity: 0.8 }}
            >
              {t("blood-transfusion.bag-zıntı-check")}
            </ByzMuiTypography>
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={2} xs={12} md={2} lg={2} xl={2}>
          <ByzTitleAndInputBox title={t("blood-transfusion.person-1")}>
            <ByzMuiRadioButton
              typographyText="blood-transfusion.suitable,blood-transfusion.not-suitable"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.suitable,blood-transfusion.not-suitable"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={3} xs={12} md={3} lg={3} xl={3}>
          <ByzTitleAndInputBox title={t("blood-transfusion.person-2")}>
            <ByzMuiRadioButton
              typographyText="blood-transfusion.suitable,blood-transfusion.not-suitable"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.suitable,blood-transfusion.not-suitable"
              layout="row"
              border="none"
            />
            <ByzMuiRadioButton
              typographyText="blood-transfusion.bag-zıntı-yes,blood-transfusion.bag-zıntı-no"
              layout="row"
              border="none"
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={6} xs={12} md={2} lg={2} xl={2} p={1}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.first-nurse-name-surname")}
          >
            <ByzMuiTextField
              sx={{
                maxwidth: "300px",
                minWidth: "50px",
                marginLeft: "8px",
              }}
              color="primary"
              variant="outlined"
              label=""
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid item sm={6} xs={12} md={2} lg={2} xl={2} p={1}>
          <ByzTitleAndInputBox
            title={t("blood-transfusion.second-nurse-name-surname")}
          >
            <ByzMuiTextField color="primary" variant="outlined" label="" />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Card>
  );
}

export default PageOne;
